import { memo } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';

import { useLanguage } from '@/shared/lib/hooks';

import { useGetQuestionMarkBySlugQuery } from '../../api/question-mark.api';

import cls from './help-popover.module.css';

type HelpPopoverProps = {
    helpId: string;
};

export const HelpPopover = memo(({ helpId }: HelpPopoverProps) => {
    const [language] = useLanguage();

    const { data } = useGetQuestionMarkBySlugQuery({
        locale: language,
        slug: helpId,
    });

    const popoverContent = !data?.content ? (
        <div>
            {/* eslint-disable-next-line i18next/no-literal-string */}
            <div className={cls.content}>Question mark slug: {helpId}</div>
        </div>
    ) : (
        <div>
            {data?.title && <div className={cls.title}>{data.title}</div>}
            {data?.content && <div className={cls.content}>{data.content}</div>}
        </div>
    );

    return (
        <Popover
            autoAdjustOverflow
            content={popoverContent}
            destroyTooltipOnHide
            overlayClassName={cls.root}
            placement="bottom"
            trigger={['click', 'hover']}
        >
            <span className={cls.trigger}>
                <QuestionCircleOutlined
                    style={{
                        fontSize: 14,
                    }}
                />
            </span>
        </Popover>
    );
});

HelpPopover.displayName = 'HelpPopover';
